import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bef313a&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=2bef313a&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=2bef313a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bef313a",
  null
  
)

export default component.exports